import GameParameterInterface from '@/models/game/parameters/interface'

interface MovieGachaLotteryParameter {
  prize: MovieGachaGamePrize
  generalValue: string
}

interface MovieGachaGamePrize {
  prizeImage: string,
}

export default class MovieGachaParameter implements GameParameterInterface {
  constructor(private parameter: MovieGachaLotteryParameter) { }

  createSetOption(): MovieGachaLotteryParameter {
    return {
      prize: this.parameter.prize,
      generalValue: this.parameter.generalValue,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
